/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import timeframeUnits from 'cio/utils/timeframe-units';
import integerToString from 'cio/utils/integer-to-string';
import ApiService from 'cio/services/api';
import ApiErrorsService from 'cio/services/api-errors';
import ActionSubjectsService from 'cio/services/action-subjects';
import DelayAbstract from 'cio/app-models/action-abstracts/delay';
import { SerializedLegacyFilter } from 'cio/types/conditions/legacy-filter';

interface DelayEditSidebarArgs {
  actionAbstract: DelayAbstract;
  isSaving: boolean;
  hasReadOnlyPermission: boolean;
}

export default class DelayEditSidebar extends Component<DelayEditSidebarArgs> {
  @service api!: ApiService;
  @service apiErrors!: ApiErrorsService;
  @service actionSubjects!: ActionSubjectsService;

  readonly delayUnits = timeframeUnits({ context: this.args.actionAbstract, countProperty: 'delayCount' });

  @integerToString('args.actionAbstract.delayCount') delayCountValue!: string;

  @action
  setConditions(conditions: SerializedLegacyFilter[]) {
    this.args.actionAbstract.preconditions = conditions;
  }
}
